import { Box as Container, CssBaseline, Toolbar } from '@mui/material'
import Footer from 'components/Footer'
import Header from 'components/Header'
import DrawerMenu from 'components/Header/components/DrawerMenu'
import React, { useState } from 'react'
import { StyledMain } from './styles'

type DefaultProps = {
  children: React.ReactNode
}

const Default: React.FC<DefaultProps> = ({ children }) => {
  const [openMenu, setOpenMenu] = useState(false)

  const handleDrawerMenu = (): void => setOpenMenu(!openMenu)

  return (
    <Container display='flex'>
      <CssBaseline />
      <Header onMenuClick={handleDrawerMenu} />
      <DrawerMenu open={openMenu} onClose={handleDrawerMenu} />
      <StyledMain>
        <Toolbar variant='dense' />
        {children}
        <Toolbar variant='dense' />
      </StyledMain>
      <Footer />
    </Container>
  )
}

export default Default
